import React, { useMemo } from "react";
import { DashboardRow, HeadCell } from "../../types/dashboard";
import CommonTable from "../../../../../grocery/components/CommonTable";

export type BusinessType = "Laundry" | "Restaurant" | "Saloon" | "Car Wash" | "";

interface DataTableProps {
  tableRows: DashboardRow[];
  headCells: HeadCell<DashboardRow>[];
  businessType: BusinessType;
}

const DataTable: React.FC<DataTableProps> = ({ tableRows, headCells, businessType }) => {
  /**
   * Hide Outstanding column for Restaurant
   * IMPORTANT: Do NOT modify row objects
   */
  const filteredHeadCells = useMemo(() => {
    if (businessType === "Restaurant") {
      return headCells.filter((cell) => cell.id !== "outstandingBalance");
    }
    return headCells;
  }, [businessType, headCells]);

  return (
    <div className="flex-[1.2] rounded-lg overflow-hidden">
      <CommonTable 
        data={tableRows}
        showToolbar={false}
        headCells={filteredHeadCells}
        title="Monthly Summary" 
        pagenation={true} 
        selectable={false}
        className="w-full min-w-full"
      />
    </div>
  );
};

export default DataTable;
